import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { restoreComicKeyFromLocationState } from './navigationState';

const PREFIX = 'scroll:';

export function useScrollRestoration(keyPrefix: string): void {
  const location = useLocation();
  const key = `${PREFIX}${keyPrefix}:${location.pathname}${location.search}`;

  useEffect(() => {
    const raw = window.sessionStorage.getItem(key);
    if (raw) {
      const y = Number.parseInt(raw, 10);
      if (Number.isFinite(y) && y > 0) {
        window.requestAnimationFrame(() => window.scrollTo(0, y));
      }
    }

    function save() {
      window.sessionStorage.setItem(key, String(window.scrollY));
    }

    window.addEventListener('pagehide', save);
    return () => {
      save();
      window.removeEventListener('pagehide', save);
    };
  }, [key]);
}

export function useRestoreComicCardOnReturn(): void {
  const location = useLocation();
  const restoreComicKey = restoreComicKeyFromLocationState(location.state);

  useEffect(() => {
    if (!restoreComicKey) return;

    const key = restoreComicKey;
    let frame = 0;
    let attempts = 0;
    const maxAttempts = 30;

    function restore() {
      const node = document.querySelector<HTMLElement>(
        `[data-comic-card-key="${CSS.escape(key)}"]`,
      );
      if (node) {
        node.scrollIntoView({ block: 'center' });
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        frame = window.requestAnimationFrame(restore);
      }
    }

    frame = window.requestAnimationFrame(restore);
    return () => window.cancelAnimationFrame(frame);
  }, [location.key, restoreComicKey]);
}
